module.exports = __webpack_public_path__ + "img/wk5.e39547ba.png";